<template>
	<div class="avsec-container__table__pagination" v-if="num_of_pages > 1">
		{{ current * limit - limit + 1 }} - {{ current * limit }} of {{ found_posts }}
		<div class="prev-link">
			<a :class="current <= 1 ? 'disabled' : ''"
			   @click.prevent="click_go_to_page( current - 1 )"
			   href=""><i class="fas fa-angle-left"></i></a>
		</div>
		<div class="next-link">
			<a :class="current >= num_of_pages ? 'disabled' : ''"
			   @click.prevent="click_go_to_page( current + 1 )"
			   href="" ><i class="fas fa-angle-right"></i></a>
		</div>
	</div>
</template>
<script setup>
import {computed, ref} from "vue";

const props = defineProps({
	found_posts: Number,
	limit: Number,
	current: Number,
	go_to_page: Function
})

// let num_of_pages = ref( Math.ceil( props.found_posts / props.limit ) )
let num_of_pages = computed( () => {
	return Math.ceil( props.found_posts / props.limit )
})

let click_go_to_page = function( page ) {
	props.go_to_page(page, props.current )
}
</script>